let expressServer = {
	handle: () => {}
};

/**
 * Mocks the express request API, returns a response simlar to the
 *  structure of an axios http request
 */
const getResponse = (resolve) => {
	let statusCode = 200;
	let sendData = (data) => resolve({ data, status: statusCode });
	let respObj =  {
		json: data => {
			sendData(data)
		},
		send: data => {
			sendData(data)
		},
		setHeader: () => {}
	};

	respObj.status = (code) => {
		//temp remove status code support, always return 200
		//statusCode = code;
		return respObj
	};

	return respObj;
}

/**
 * Server API works in place of axios on server side code
 * Rather than making an HTTP request on the server the expess app is
 * passed in, and the express internal api 'handle' is used to execute the
 *  request against the regestered routes on the app
 */
class ServerAPI {
	constructor(server) {
		//when the server starts it will pass express in here,
		//overwritting the ref here so that subsequent API calls will be 
		// handled by th express server
		expressServer = server || expressServer;
	}

	get(path, options={}) {
		const req = { 
			url: path, 
			method: 'GET', 
			query: options.params, 
			headers: { 'Transfer-Encoding': 'chunked' } 
		};
		return new Promise((resolve, reject) => {
			try{
				expressServer.handle(
					req, 
					getResponse(resolve)
				);
			}catch(e){
				reject(e);
			}
		});
	}

	post(path, body, options={}) {
		const req = { 
			url: path, 
			method: 'POST', 
			body: body,
			query: options.params, 
			headers: { 'Transfer-Encoding': 'chunked' } 
		};
		
		return new Promise((resolve, reject) => {
			try{
				expressServer.handle(
					req, 
					getResponse(resolve)
				);
			}catch(e){
				reject(e);
			}
		});
	}
}

export default ServerAPI;
